// Varukorgsskydd: en anpassad Kentucky-produkt och dess tillval (brodyr, kantband, passpoal) hör ihop.
// - Tas produkten bort, tas tillvalen bort.
// - Ändras antalet, följer tillvalen med.
// - Tas ett tillval bort, läggs det tillbaka (annars skulle designen sys utan att vara betald).
// Servern kontrollerar dessutom varje order innan den skickas till Kentucky.
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else api.start(root);
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';

  var RESTORED = 'Brodyr, kantband och passpoal hör ihop med den anpassade produkten och kan inte tas bort var för sig. ' +
    'Ta bort produkten om du vill ta bort designen.';
  var REMOVED = 'Ett tillval i din design kunde inte läggas tillbaka, så den anpassade produkten togs bort ur varukorgen. ' +
    'Gör gärna om designen från produktsidan.';
  var CART_CHANGE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;

  function parseServices(value) {
    var result = {};
    String(value || '').split(',').forEach(function (part) {
      var bits = part.split(':');
      var id = parseInt(bits[0], 10);
      var count = parseInt(bits[1], 10);
      if (id > 0 && count > 0) result[String(id)] = count;
    });
    return result;
  }

  function belongsTo(main) {
    return main.product_title + ' (designkod ' + main.properties._arana_code + ')';
  }

  /** Räknar ut vad som behöver ändras i varukorgen (cart.js) för att varje design ska vara hel. */
  function computeActions(cart) {
    var groups = {};
    var names = [];
    (cart.items || []).forEach(function (item) {
      var props = item.properties || {};
      var group = props._arana_group;
      if (!group) return;
      if (!groups[group]) {
        groups[group] = { main: null, services: [], keys: [] };
        names.push(group);
      }
      groups[group].keys.push(item.key);
      if (props._arana_code) groups[group].main = item;
      else groups[group].services.push(item);
    });

    var updates = {};
    var adds = [];
    var groupKeys = {};
    names.forEach(function (group) {
      var entry = groups[group];
      groupKeys[group] = entry.keys;
      if (!entry.main) {
        entry.services.forEach(function (service) { updates[service.key] = 0; });
        return;
      }
      var perUnit = parseServices(entry.main.properties._arana_services);
      var seen = {};
      entry.services.forEach(function (service) {
        var id = String(service.variant_id);
        var wanted = seen[id] ? 0 : (perUnit[id] || 0) * entry.main.quantity;
        seen[id] = true;
        if (service.quantity !== wanted) updates[service.key] = wanted;
      });
      Object.keys(perUnit).forEach(function (id) {
        if (seen[id]) return;
        var properties = { _arana_group: group };
        properties['Tillhör'] = belongsTo(entry.main);
        adds.push({ id: Number(id), quantity: perUnit[id] * entry.main.quantity, properties: properties });
      });
    });
    return { updates: updates, adds: adds, groupKeys: groupKeys };
  }

  function start(win) {
    if (!win.fetch || win.__aranaCartGuard) return;
    win.__aranaCartGuard = true;

    var cartRoot = (win.Shopify && win.Shopify.routes && win.Shopify.routes.root) || '/';
    var nativeFetch = win.fetch.bind(win);
    var running = false;
    var again = false;
    var timer = null;

    function postJson(path, body) {
      return nativeFetch(cartRoot + path, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      });
    }

    // Skydd mot omladdningsloopar om varukorgen av någon anledning inte går att rätta.
    function reloadCount(value) {
      try {
        if (value === undefined) return parseInt(win.sessionStorage.getItem('aranaGuardReloads') || '0', 10);
        win.sessionStorage.setItem('aranaGuardReloads', String(value));
      } catch (e) {
        return 0;
      }
      return value;
    }

    function apply(actions) {
      var message = null;
      var chain = Promise.resolve();
      if (actions.adds.length) {
        chain = chain
          .then(function () { return postJson('cart/add.js', { items: actions.adds }); })
          .then(function () { message = RESTORED; })
          .catch(function () {
            actions.adds.forEach(function (add) {
              (actions.groupKeys[add.properties._arana_group] || []).forEach(function (key) { actions.updates[key] = 0; });
            });
            message = REMOVED;
          });
      }
      return chain
        .then(function () {
          if (Object.keys(actions.updates).length) return postJson('cart/update.js', { updates: actions.updates });
        })
        .then(function () { return message; });
    }

    function run() {
      if (running) {
        again = true;
        return;
      }
      running = true;
      nativeFetch(cartRoot + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          var actions = computeActions(cart);
          if (!actions.adds.length && !Object.keys(actions.updates).length) {
            reloadCount(0);
            return;
          }
          if (reloadCount() >= 3) return;
          return apply(actions).then(function (message) {
            if (message) win.alert(message);
            reloadCount(reloadCount() + 1);
            win.location.reload();
          });
        })
        .catch(function (error) {
          if (win.console) win.console.warn('Kentucky design: kunde inte kontrollera varukorgen', error);
        })
        .then(function () {
          running = false;
          if (again) {
            again = false;
            schedule();
          }
        });
    }

    function schedule() {
      win.clearTimeout(timer);
      timer = win.setTimeout(run, 300);
    }

    win.fetch = function (input) {
      var promise = nativeFetch.apply(null, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && (input.url || input.href)) || '';
        if (CART_CHANGE.test(url)) promise.then(schedule, schedule);
      } catch (e) { /* ignorera */ }
      return promise;
    };

    var xhrOpen = win.XMLHttpRequest && win.XMLHttpRequest.prototype.open;
    if (xhrOpen) {
      win.XMLHttpRequest.prototype.open = function (method, url) {
        try {
          if (CART_CHANGE.test(String(url))) this.addEventListener('loadend', schedule);
        } catch (e) { /* ignorera */ }
        return xhrOpen.apply(this, arguments);
      };
    }

    if (win.AranaCart && win.AranaCart.hasDesign) schedule();
    win.addEventListener('pageshow', function (event) {
      if (event.persisted) schedule();
    });
  }

  return { computeActions: computeActions, parseServices: parseServices, start: start };
});
